exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-loading{text-align:center}.comment-loading svg{width:3.75em;-webkit-animation:spin 1.5s ease infinite;animation:spin 1.5s ease infinite}.comment-loading svg .ring{fill:none;stroke:rgba(252,49,113,.3);stroke-width:2}.comment-loading svg .ball{fill:#fc2f70;stroke:none}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loading-fade-enter-active,.loading-fade-leave-active{-webkit-transition:all .1s ease-in-out;transition:all .1s ease-in-out}.loading-fade-enter,.loading-fade-leave-to{opacity:0}", ""]);

// exports
